import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import styled from 'styled-components';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { useMemo } from 'react';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "LineItemTax__StyledDiv"
})(["white-space:-o-pre-wrap;"]);
const LineItemTax = ({
  currencyCode,
  label,
  taxAmount
}) => {
  const taxAmountAndLabel = useMemo(() => {
    if (label) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "payments.lineItems.taxAmountAndLabel_jsx",
        options: {
          value: taxAmount,
          currencyCode,
          label
        },
        elements: {
          Price: FormattedIntlCurrency
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "payments.lineItems.taxAmount_jsx",
      options: {
        value: taxAmount,
        currencyCode
      },
      elements: {
        Price: FormattedIntlCurrency
      }
    });
  }, [currencyCode, label, taxAmount]);
  return /*#__PURE__*/_jsx(StyledDiv, {
    children: /*#__PURE__*/_jsx(Text, {
      color: "text-core-subtle",
      as: "small",
      "data-test-id": "line-item-tax",
      children: taxAmountAndLabel
    })
  });
};
export default LineItemTax;